var React = require('react');

function MobileMenu (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("rect",{"id":"line-1","x":"8.5","y":"1.5","width":"17.5","height":"2","fill":"#323D74","key":0}),React.createElement("rect",{"id":"line-2","x":"0","y":"8.5","width":"26","height":"2","fill":"#323D74","key":1}),React.createElement("rect",{"id":"line-3","x":"5","y":"15.5","width":"21","height":"2","fill":"#323D74","key":2})]));
}

MobileMenu.defaultProps = {"width":"28","height":"17","viewBox":"0 0 28 18"};

module.exports = MobileMenu;

MobileMenu.default = MobileMenu;
